<template>
  <ec-flex alignItems="center" class="ec-title-section" :hGap="16">
    <slot></slot>
  </ec-flex>
</template>
<script lang="ts" setup></script>
